import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../shared/services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AlreadyLoggedInGuard {
  private readonly loginService = inject(LoginService);
  private readonly router = inject(Router);


  public canActivate(): boolean {
    if (this.loginService.user) {
      this.router.navigate(['/admin']);
      return false;
    } else {
      return true;
    }
  }

}
